<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-form-phones
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @download-excel="onDownloadExcel"
          @filtering="onFilter"
        ></filter-form-phones>
        <phone-row v-if="isShowAddDialog" mode-add
                   @cancel="isShowAddDialog = false"
                   @saved="onSaved"
        />
        <table-paginated-phones
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
          @delete-item="onPaginatedItemDelete"
        ></table-paginated-phones>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>

      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
      <v-btn
        color="pink"
        dark
        fixed
        bottom
        right
        fab
        @click="isShowAddDialog = true"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { PER_PAGE_ORDERS } from '@/constants/listing';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import TablePaginatedPhones from '@/components/listings/TablePaginatedPhones.vue';
import paginationMixin from '@/mixins/listing/paginationMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import downloadReport from '@/mixins/reports/downloadReport';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import PhoneRow from '@/components/listings/PhoneRow.vue';
import FormPhoneProxy from '@/proxies/FormPhones/FormPhoneProxy';
import FilterFormPhones from '@/components/listings/FilterFormPhones.vue';

export default {
  name: 'Listing',
  mixins: [
    defaultListingMixin,
    paginationMixin,
    updatePageContentMixin,
    downloadReport,
  ],
  components: {
    ModalLoading,
    TablePaginatedPhones,
    PaginationListing,
    PhoneRow,
    FilterFormPhones,
  },
  data() {
    return {
      reportMethodName: 'phonesListingReport',
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      isShowAddDialog: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
        search_contact: '',
      },
    };
  },
  created() {
    this.isRequestingNow = true;
  },
  methods: {
    onPaginatedItemDelete() {
      this.fetchData();
    },
    onSaved() {
      this.isShowAddDialog = false;
      this.fetchData();
    },
    fetchData() {
      new FormPhoneProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.form_phones;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>

<style scoped>

</style>
